module.exports = __webpack_public_path__ + "img/GAME_THREE2.c06d0cc9.jpg";